const FIREFLIES_CONFIG = {
  count: 500,
  color: 0xffaa44, // More golden, magical glow for spooky atmosphere
  size: {
    desktop: 90,
    mobile: 60,
  },
  spawnCube: {
    position: { x: 0, y: 3.5, z: 0 },
    size: { x: 16, y: 5, z: 16 },
  },
}

export { FIREFLIES_CONFIG };
